import { render, staticRenderFns } from "./discussList.vue?vue&type=template&id=337bea22"
import script from "./discussList.vue?vue&type=script&lang=js"
export * from "./discussList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports